import React from 'react';
import PropTypes from 'prop-types';
import { actions } from 'farmx-redux-core';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { RWebShare } from 'react-web-share';
import { useTracking } from '../../../helper/mixpanel';
import { getActionText } from './recommendation';
import { renderTemplateString } from '../../../helper/templateString';

const { updateRecommendation } = actions;

export function RecommendationActionButtons(props) {
  const {
    onClick, blockId, recommendation, actionText, recommendationType,
  } = props;
  const { t } = useTranslation();
  const tracking = useTracking();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const showActionBtn = actionText && actionText !== 'no_action';
  const isFrozen = recommendation?.[0]?.isFrozen;
  const isGroundMission = recommendationType === 'ground_mission';
  const recommendationText = isGroundMission ? 'Ground Mission' : 'Anomaly';

  const { selectedTab } = location.state ?? {};
  function customOnClick(type) {
    if (type === 'investigate') {
      if (onClick) onClick();
      history.push({
        pathname: `/recommendation/anomaly/investigate/${blockId}`,
        state: {
          from: location.pathname,
          selectedTab,
          anomaly: recommendation,
        },
      });
      if (tracking) tracking.track('Clicked Investigate Button');
    } else if (type === 'dismiss') {
      dispatch(updateRecommendation({
        id: recommendation?.[0]?.id,
        type: !isGroundMission ? 'imagery' : 'ground_mission',
        data: {
          isFrozen: true,
          dateFrozen: moment().toISOString(),
          freezeType: 'dismiss',
        },
      }));
      if (!location?.pathname?.includes('map')) {
        history.push({
          pathname: '/recommendation',
          state: { selectedTab },
        });
      }
      if (tracking) tracking.track(`Dismissed ${recommendationText} Detail`, recommendation?.[0]);
    } else if (isFrozen && type === 'undo_dismiss') {
      dispatch(updateRecommendation({
        id: recommendation?.[0]?.id,
        type: !isGroundMission ? 'imagery' : 'ground_mission',
        data: {
          isFrozen: false,
          dateFrozen: moment().toISOString(),
        },
      }));
      if (!location?.pathname?.includes('map')) {
        history.push({
          pathname: '/recommendation',
          state: { selectedTab },
        });
      }
      if (tracking) {
        tracking.track(`Clicked Undo Dismissed ${recommendationText} Detail`, recommendation?.[0]);
      }
    }
  }

  const shareUrl = window.location.href;

  const translatedDescription = renderTemplateString(
    t(recommendation?.description),
    {
      irrigation_duration: Math.round(
        moment.duration(recommendation?.irrigationDuration).asHours()
      ),
      date_wilting_point: moment(recommendation?.data?.dateWiltingPoint).format(
        "D MMMM"
      ),
    }
  );

  return (
    <div className="action-footer recommendation-detail-actions
     recommendation-anomaly-action-buttons anomaly-action-button scheduling-investigation-button"
    >
      {showActionBtn ? (
        <Button
          size="large"
          block
          type="primary"
          onClick={() => customOnClick('investigate')}
        >
          {t(getActionText(actionText))}
        </Button>
      ) : null }

      <RWebShare
        className="schedule-share"
        data={{
          text: translatedDescription,
          url: shareUrl,
          title: t(!isGroundMission ? 'Imagery Anomaly' : 'Ground Mission'),
        }}
        onClick={() => {
          if (tracking) {
            tracking.track(`Shared ${!isGroundMission ? 'Imagery Anomaly' : 'Ground Mission'}`);
          }
        }}
      >
        <Button
          size="large"
          block
          data-testid="share-button"
        >
          {t('Share')}
        </Button>
      </RWebShare>

      <Button
        size="large"
        block
        onClick={() => customOnClick(isFrozen ? 'undo_dismiss' : 'dismiss')}
        data-testid="dismiss-button"
      >
        {isFrozen ? t('Undo Dismiss') : t('Dismiss')}
      </Button>
    </div>
  );
}

RecommendationActionButtons.propTypes = {
  onClick: PropTypes.func,
  blockId: PropTypes.number,
  recommendation: PropTypes.shape({
    description: PropTypes.string,
    data: PropTypes.shape({}),
  }),
  actionText: PropTypes.string,
  recommendationType: PropTypes.string,
};

RecommendationActionButtons.defaultProps = {
  onClick: null,
  blockId: null,
  recommendation: null,
  actionText: null,
  recommendationType: null,
};
